import { render } from "./TeethStone.vue?vue&type=template&id=d14b22cc&scoped=true&ts=true"
import script from "./TeethStone.vue?vue&type=script&lang=ts"
export * from "./TeethStone.vue?vue&type=script&lang=ts"

import "./TeethStone.vue?vue&type=style&index=0&id=d14b22cc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d14b22cc"]])

export default __exports__